import { GridDiv, GridDivContainer } from "../components/GridDiv";
import { PageBody } from "../components/PageBody";
import { DictionaryDefinition } from "../components/DictionaryDefinition";
import { UnderlinedTag } from "../components/UnderlinedTag";
import { ProjectLink } from "../components/ProjectLink";
import { Helmet } from "react-helmet-async";
import { headlineTags } from "../config/theme";
import { getFeaturedProjects } from "../config/projects";
import { getSEOForPath } from "../config/seo";
import { useLocation } from "react-router-dom";

// Get featured projects from centralized config
const featuredProjects = getFeaturedProjects();


export function Home() {
	const location = useLocation();
	const seo = getSEOForPath(location.pathname);
	
	return (
		<PageBody widthClass="max-w-screen-lg">
			<Helmet>
				<title>{seo.title}</title>
				<meta name="description" content={seo.description}></meta>
				{seo.keywords && <meta name="keywords" content={seo.keywords}></meta>}
			</Helmet>
			<div className="px-4 sm:px-6 pt-4 sm:pt-8">
				<h1 className="text-left sm:text-center tracking-tight font-bold text-5xl sm:text-6xl mb-6 sm:mb-8 text-gray-800">
					Data-driven insights using{' '}
					<UnderlinedTag text={headlineTags[0].text} colorClass={headlineTags[0].colorClass} />
					,<br className="sm:hidden" />
					<span className="hidden sm:inline">{' '}</span>
					<UnderlinedTag text={headlineTags[1].text} colorClass={headlineTags[1].colorClass} />
					{' '}and{' '}
					<UnderlinedTag text={headlineTags[2].text} colorClass={headlineTags[2].colorClass} />
				</h1>
			</div>
			<div className="px-4 sm:px-6">
				<div className="max-w-screen-md mx-auto w-full">
					<p className="pt-4 sm:pt-6 pb-4 sm:pb-6 text-base sm:text-lg text-gray-700 leading-relaxed">
						I'm a Staff Analytics Engineer specializing in analytics schema design, 
						data pipeline engineering, and scalable data infrastructure. This site 
						showcases my work across sports analytics, predictive modeling, and 
						data visualization—from enterprise analytics systems to personal projects 
						exploring the intersection of data and sports.
					</p>
				</div>
				<div className="w-full">
					<GridDivContainer className="mt-4 sm:mt-6">
						{featuredProjects.map((project) => (
							<GridDiv
								key={project.to}
								widthClasses="w-full md:w-1/2"
							>
								<ProjectLink
									to={project.to}
									title={project.title}
									icon={project.icon}
									colorClass={project.colorClass}
									iconColor={project.iconColor}
									isCustomIcon={project.isCustomIcon}
								/>
							</GridDiv>
						))}
					</GridDivContainer>
					<div className="mt-8 sm:mt-10 border-t border-gray-200 pt-8 sm:pt-10">
						<DictionaryDefinition />
					</div>
				</div>
			</div>
		</PageBody>
	);
};
